import {useEffect, useState} from "react";

function useOnChangeTextSendForSignModal(selectedCargoCaseBol, selectedCargoCaseMan) {

    const [isTextForSendForSignModal, setTextForSendForSignModal] = useState('');

    useEffect(() => {
        let isMount = true;

        if (selectedCargoCaseBol !== undefined) {
            isMount && setTextForSendForSignModal('Do you want to submit BOL for signature? The BOL will be signed by Capitan?')
        } else if ((selectedCargoCaseMan !== undefined && selectedCargoCaseMan[0]?.status === 'DRAFT') || (selectedCargoCaseMan !== undefined && selectedCargoCaseMan[0]?.status === 'TO_CORRECT')) {
            isMount && setTextForSendForSignModal('Do you want to submit MAN for signature? The MAN will be signed by Capitan?')
        } else if (selectedCargoCaseMan !== undefined && selectedCargoCaseMan[0]?.status === 'SIGNED_CAPTAIN') {
            isMount && setTextForSendForSignModal('Do you want to submit MAN for signature? The MAN will be signed by Custom?')
        } else {
            setTextForSendForSignModal('');
        }

        return () => {
            isMount = false;
        }
    },[selectedCargoCaseBol, selectedCargoCaseMan])

    return {isTextForSendForSignModal};
}

export default useOnChangeTextSendForSignModal;
